var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset42(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 404.13 105.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #634a32;\n      }\n      .skin {\n        fill: #dcba8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.51,35.36C39.14,44.64,0,86.47,0,86.47S50.64,113.23,106,104s97.69-32.18,94.51-51.12S149.89,26.07,94.51,35.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.78,35.27c-55.52-8.38-102.85.23-105.71,19.22S242.9,95.67,298.42,104,404.13,84.81,404.13,84.81,364.31,43.64,308.78,35.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M221.26,65.88A14,14,0,0,1,248,60c5.63-6.11,8.92-13.4,8.92-21.23C256.88,17.36,232.41,0,202.23,0s-54.66,17.36-54.66,38.79c0,7.26,2.82,14.05,7.71,19.86a14,14,0,1,1,23.49,15.17,73.53,73.53,0,0,0,23.46,3.75,74,74,0,0,0,21.88-3.24A13.94,13.94,0,0,1,221.26,65.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset42);
export default __webpack_public_path__ + "static/media/Asset 42.8b0a34c9.svg";
export { ForwardRef as ReactComponent };